import React, { Fragment } from 'react';
import { Route, RouteProps, Switch } from 'react-router';
import { NavMenu } from '../components/core/NavMenu';
import { appDomain } from '../domain/AppDomain';
import { AppRoutes } from '../domain/navigation/AppRoutes';
import { AttentionDaysDetailView } from "../view/AttentionDaysDetailView";
import { AttentionDaysView } from '../view/AttentionDaysView';
import { DayBhvView, DayView } from '../view/DayView';
import { EmployeeGroupDetailView } from "../view/EmployeeGroupDetailView";
import { EmployeeGroupListView } from '../view/EmployeeGroupListView';
import { MonthView } from '../view/MonthView';
import { RedirectToToday } from '../view/Redirects';

interface PrivateRouteProps extends RouteProps {
    permission: string;
}

export class PrivateRoute extends React.Component<PrivateRouteProps> {
    render() {
        const hasPermission = appDomain.IRequestPermission.hasPermission(this.props.permission);
        if (hasPermission) {
            return <Route {...this.props}></Route>
        }
    }
}

export function PrivateRoutes() {
    return (<Fragment>
        <NavMenu />
        <Switch>
            <Route exact path={AppRoutes.home} component={RedirectToToday} />
            <Route path={AppRoutes.day} component={DayView} />
            <Route path={AppRoutes.bhvDay} component={DayBhvView} />
            <Route path={AppRoutes.month} component={MonthView} />
            <PrivateRoute exact path={AppRoutes.attentiondays} component={AttentionDaysView} permission="attentiondays" />
            <PrivateRoute path={AppRoutes.attentiondays + "/:id"} component={AttentionDaysDetailView} permission="attentiondays" />
            <PrivateRoute exact path={AppRoutes.employeegroups} component={EmployeeGroupListView} permission="employeegroups" />
            <PrivateRoute path={AppRoutes.employeegroups + "/:id"} component={EmployeeGroupDetailView} permission="employeegroups" />
            <Route component={RedirectToToday} />
        </Switch>
    </Fragment>);
}
